import thunk from 'redux-thunk';
import logger from 'redux-logger';
import { createStore, applyMiddleware, compose } from 'redux';
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync';
import reducers from './reducers';

// eslint-disable-next-line import/no-mutable-exports
let store;

const isSyncTab = false;

export const configureStore = (initialState) => {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const middlewares = [thunk];
  if (isSyncTab) {
    middlewares.push(createStateSyncMiddleware());
  }
  if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    middlewares.push(logger);
  }

  const appliedMiddleware = applyMiddleware(...middlewares);
  store = initialState
    ? createStore(
      reducers,
      initialState,
      composeEnhancers(appliedMiddleware),
    )
    : createStore(reducers, composeEnhancers(appliedMiddleware));
  if (isSyncTab) {
    initMessageListener(store);
  }
  return store;
};
export default store;
const getStore = () => store;
export const getState = () => getStore() && getStore().getState();
export const dispatch = (data) => getStore() && getStore().dispatch(data);
